// see: https://stackoverflow.com/questions/1248081/get-the-browser-viewport-dimensions-with-javascript
export function viewportDimensions() {
	const docEl = document.documentElement
	return {
		width: Math.max(docEl.clientWidth, window.innerWidth || 0),
		height: Math.max(docEl.clientHeight, window.innerHeight || 0),
	}
}

/**
 * Get an element's distance from the top of the page
 * @param  {Node}   elem The element
 * @return {Number}      Distance from the top of the page
 * SEE: https://gomakethings.com/ditching-jquery/#get-distances-to-the-top-of-the-document
*/
export function getElementOffset(element) {
	var location = 0
	if (element.offsetParent) {
		do {
			location += element.offsetTop
			element = element.offsetParent
		} while (element)
	}
	return location >= 0 ? location : 0
}
